import React, { useEffect } from 'react';
import { useTranslation } from '../../../shared/hooks/useTranslation';
import { useAppDispatch, useAppSelector } from '../../../shared/hooks/sharedHooks';
import ActionToast from '../../../shared/components/ActionToast';
import { hideAccessDenied, showAccessDenied } from '../../accessDeniedSlice';
import { setErrorHandlerCallbacks } from '../../../core/errorHandler';

const AccessDeniedNotification = () => {
  const { translate } = useTranslation(['common']);
  const dispatch = useAppDispatch();
  const { isAccessDenied } = useAppSelector((state: any) => state.accessDenied);

  useEffect(() => {
    setErrorHandlerCallbacks({
      onAccessDenied: () => {
        dispatch(showAccessDenied());
      }
    });

    return () => {
      dispatch(hideAccessDenied());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isAccessDenied) {
      const timer = setTimeout(() => {
        dispatch(hideAccessDenied());
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isAccessDenied, dispatch]);

  const handleCloseNotification = () => {
    dispatch(hideAccessDenied());
  };

  return (
    <ActionToast
      open={isAccessDenied}
      variant="error"
      message={translate('common:accessDenied')}
      onClose={handleCloseNotification}
      duration={6000}
    />
  );
};

export default AccessDeniedNotification;
